import React from "react";
import Seo from "../../../components/public/Seo";
import "../../../styles/legal.css";

export default function LicenseNotices() {
  return (
    <>
      <Seo
        title="Licence Notices — Veya"
        description="Open-source and third-party software licence notices for Veya."
      />

      <main className="legal-page">
        <section className="legal-hero legal-hero--narrow">
          <p className="legal-kicker">Licence Notices</p>
          <h1>Open-source & third-party licence notices</h1>
          <p>
            Veya uses open-source and third-party software to operate the
            platform. Each package remains licensed under its own licence terms.
          </p>
          <p className="legal-updated">Last updated: May 2026</p>
        </section>

        <article className="legal-document">
          <section>
            <h2>1. Open-source software</h2>
            <p>
              Veya is built using open-source and third-party software across
              the frontend, backend, database, infrastructure and supporting
              tooling.
            </p>
            <p>
              Open-source software remains the property of its respective
              authors and contributors. Use of each package is governed by the
              licence that applies to that package.
            </p>
          </section>

          <section>
            <h2>2. Frontend dependencies</h2>
            <p>
              Veya’s frontend may include packages and libraries used for user
              interface rendering, routing, styling, animation, 3D rendering,
              product display, state management, build tooling and developer
              workflows.
            </p>
            <p>
              Examples may include libraries from the React, Vite, Three.js and
              related JavaScript ecosystems, depending on the current production
              build.
            </p>
          </section>

          <section>
            <h2>3. Backend dependencies</h2>
            <p>
              Veya’s backend may include packages and libraries used for API
              routing, database access, authentication, validation, image
              processing, background tasks, integrations and deployment.
            </p>
            <p>
              Examples may include libraries from the FastAPI, SQLAlchemy,
              Pydantic, Uvicorn and related Python ecosystems, depending on the
              current production build.
            </p>
          </section>

          <section>
            <h2>4. Generated licence reports</h2>
            <p>
              Before launch and from time to time after major dependency
              changes, Veya should generate and review dependency licence
              reports for both frontend and backend packages.
            </p>

            <div className="legal-code-block">
              <p>Frontend:</p>
              <code>npx license-checker --production --summary</code>
              <code>
                npx license-checker --production --json &gt;
                public/licenses/frontend-licenses.json
              </code>
            </div>

            <div className="legal-code-block">
              <p>Backend:</p>
              <code>pip-licenses --summary</code>
              <code>
                pip-licenses --format=json --output-file=backend-licenses.json
              </code>
            </div>
          </section>

          <section>
            <h2>5. No endorsement</h2>
            <p>
              Reference to open-source or third-party software does not imply
              endorsement of Veya by the authors, maintainers or contributors of
              those packages.
            </p>
          </section>

          <section>
            <h2>6. Licence enquiries</h2>
            <p>
              For questions about Veya’s licence notices, contact{" "}
              <a href="mailto:hello@veya.co.nz">hello@veya.co.nz</a>.
            </p>
          </section>
        </article>
      </main>
    </>
  );
}